import { hairdresserConstants } from '../_constants';
import { productConstants } from '../_constants/productConstants';


const initialState = {
};

const initialClientListState = {
  searchKey: "",
  filters: {
    teamMembers: [],
    teamMemberNames: null,
    startDate: null,
    endDate: null,
    minSales: null,
    maxSales: null,
    searchQuery: ""
  },
  sortField: 'name',
  sortOrder: 'asc',
  currentPage: 1,
  scrollPosition: 0,
  clientData: [], // Store accumulated client data for restoration
  hasData: false
};


export function hairdresserClientCsv(state = initialState, action) {
  // console.log('action.type',action);
  switch (action.type) {
    case hairdresserConstants.HAIRDRESSER_CLIENT_CSV_DOWNLOAD:
      let data = action.getHairdresserClientSuccess;
      return data;

    case hairdresserConstants.HAIRDRESSER_CLIENT_ERROR:
      return {};

    case hairdresserConstants.HAIRDRESSER_CLIENT_CLEAR:
      return {};

    default:
      return state
  }
}

export function hairdresserClient(state = initialState, action) {
  // console.log('action.type',action);
  switch (action.type) {
    case hairdresserConstants.HAIRDRESSER_CLIENT_SUCCESS:
      let data = action.getHairdresserClientSuccess;
      return data;


    case hairdresserConstants.HAIRDRESSER_CLIENT_ERROR:
      return {};

    case hairdresserConstants.HAIRDRESSER_CLIENT_CLEAR:
      return {};

    default:
      return state
  }
}

// New reducer for persisting client list page state
export function hairdresserClientListState(state = initialClientListState, action) {
  switch (action.type) {
    case hairdresserConstants.HAIRDRESSER_CLIENT_LIST_STATE_SAVE:
      return {
        ...state,
        ...action.payload,
        hasData: true
      };

    case hairdresserConstants.HAIRDRESSER_CLIENT_LIST_STATE_CLEAR:
      return initialClientListState;

    default:
      return state;
  }
}


export function selectedClient(state = initialState, action) {
  switch (action.type) {
    case productConstants.SELECTED_CLIENT:
      let clientData = action.data;
      return clientData;
    default:
      return state
  }
}
